






















import { omega, params } from '@didi/driver-biz-sdk'
import { invokeEntrance } from '@/common/biz/share'
import { defineComponent, computed, ref, PropType } from '@vue/composition-api'
import { ACTIVITY_STATUS_MAP, BTN_STATUS_MAP, isInApp, PROTOCAOL_LIST } from '@/common/biz/constants'
import { showToast } from 'common/ts/toast'
import { join, grantHandler } from './index'
import { usePageInfo } from '@/store'
import type { InsuranceInfoRes } from 'api/api-type'
import { storeToRefs } from 'pinia'

export default defineComponent({
  props: {
    btnInfo: {
      type: Object as PropType<InsuranceInfoRes['show_button']>,
      default: () => {
        return {}
      }
    },
    activityStatus: {
      type: Number,
      default: -1
    },
    notMatchInfo: {
      type: Object as PropType<InsuranceInfoRes['match_condition']>,
      default: () => {
        return {}
      }
    },
    companyId: {
      type: Number,
      default: 0
    },
    cityId: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const store = usePageInfo()
    const { pageInfo } = storeToRefs(store)
    const isMaxLimit = computed(() => {
      const info = pageInfo.value
      if (!info) return false

      if (info.self_pay_upper_limit && info.show_button.join_button === 1) {
        return true
      }

      return false
    })

    const checked = ref(false)
    function check() {
      checked.value = !checked.value
    }

    const emptyFn = () => { /** empty fn */ }
    const btn = computed(() => {
      if (!isInApp) return ''

      const btnInfo = props.btnInfo
      const notMatchInfo = (props.notMatchInfo || {})
      if (btnInfo.join_button === BTN_STATUS_MAP.show) {
        return {
          text: '查看保障详情',
          disabled: false,
          showProtocol: true,
          act: join
        }
      }
      if (btnInfo.join_button === BTN_STATUS_MAP.disabled) {
        omega.trackEvent('am_c_insure_medinsursland_sw', {
          text: notMatchInfo.content,
          type: notMatchInfo.type
        })
        return {
          // 业务逻辑：司机满足目标人群（开城、业务线等），但因为司机自己原因不满足流水等原因时，也展示 查看保障详情
          text: ['income', 'online_time', 'service_time'].includes(notMatchInfo.type) ? '查看保障详情' : '敬请期待',
          disabled: true,
          disabledText: notMatchInfo.content,
          act: emptyFn
        }
      }
      const activityStatus = props.activityStatus
      if (activityStatus === ACTIVITY_STATUS_MAP.wait && btnInfo.share_button) {
        return {
          text: '一键分享',
          disabled: false,
          disabledText: notMatchInfo.content,
          act: share
        }
      }
      return ''
    })

    function clickBtn() {
      if (!btn.value) return
      if (isMaxLimit.value) {
        showToast('您已通过自费渠道购买医疗保障，无法使用补贴继续投保', 'warn', {
          $class: { 'my-biz-toast1': true }
        })
        return
      }
      if (btn.value.showProtocol && !checked.value) {
        showToast('请阅读并勾选协议')
        return
      }
      btn.value.act(props.companyId, props.cityId)
    }

    function share() {
      omega.trackEvent('am_c_insure_endowmentbjion_share_ck', { type: 2 })
      invokeEntrance()
    }

    function linkToPage(type: '1'|'2') {
      window.location.href = PROTOCAOL_LIST[type]
    }

    if (params.urlParams.grant) {
      check()
      grantHandler(props.companyId, props.cityId)
    }
    return {
      checked,
      check,
      clickBtn,
      btn,
      linkToPage
    }
  }
})
